var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"checkbox",staticClass:"tc-checkbox-native",attrs:{"type":"checkbox","disabled":_vm.disabled,"role":"checkbox","aria-checked":_vm.value === null ? 'mixed' : _vm.value,"aria-label":_vm.i18nAriaLabel},domProps:{"checked":_vm.value === true},on:{"change":_vm.toggleValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }